import { render, staticRenderFns } from "./AgendadorTarefas.vue?vue&type=template&id=104f2d04&"
import script from "./AgendadorTarefas.vue?vue&type=script&lang=js&"
export * from "./AgendadorTarefas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports